"use client";

import React from "react";
import AniIcon from "./AniIcon";

const AniTag = ({ children, onRemove, removeLabel, disabled = false }: {
  children: React.ReactNode;
  onRemove?: () => void;
  removeLabel?: string;
  disabled?: boolean;
}) => (
  <span data-token={onRemove ? "Ani Tag/Removable" : "Ani Tag/Status"}
    data-disabled={disabled || undefined}
    className={`ani-tag ani-tint${onRemove ? " ani-tag--removable" : ""}`}>
    <span className="ani-tag-label">{children}</span>
    {onRemove && (
      <button type="button" className="ani-tag-remove" disabled={disabled} data-token="Remove action"
        aria-label={removeLabel ?? `Remove ${String(children)}`} onClick={onRemove}>
        <AniIcon name="x" />
      </button>
    )}
  </span>
);

export default AniTag;
